import { render } from "./UserProfileDropdown.vue?vue&type=template&id=27dc86f9&scoped=true&ts=true"
import script from "./UserProfileDropdown.vue?vue&type=script&lang=ts"
export * from "./UserProfileDropdown.vue?vue&type=script&lang=ts"

import "./UserProfileDropdown.vue?vue&type=style&index=0&id=27dc86f9&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dc86f9"]])

export default __exports__